<template> 
  <div> 
    <div class="page-title flex-row me-3 mt-3"> 
        <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('accounting_voucher_operations') }}
        </h1>  
        <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
            <li class="breadcrumb-item text-gray-600">
                <a href="#" class="text-gray-600 text-hover-primary">
                    <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                </a>
            </li>  
            <li class="breadcrumb-item text-primary">{{ $t('accounting') }}</li> 
            <li class="breadcrumb-item text-primary">{{ $t('accounting_transaction') }}</li>
            <li class="breadcrumb-item text-gray-600">{{ $t('accounting_voucher_operations') }}
                <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
            </li>    
        </ul> 
    </div>  
    <div class="content flex-row-fluid mt-4" id="kt_content"> 
        <!-- <StatsBar></StatsBar> -->
        <div class="card">
            <div class="card-header border-0 pt-6">
                <div class="card-title">
                    <router-link to="/AccountingVoucherCreate" v-if="this.$isCredentialActive(49,'I')">
                        <button type="button" class="btn btn-light-primary border border-primary me-3">
                            <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor"/>
                                <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor"/>
                                <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor"/>
                            </svg>
                            </span>
                            {{ $t('create_new_voucher') }}
                        </button>
                    </router-link> 
                </div>
                <div class="card-toolbar">
                    <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(49,'R')">
                        <Popper hover placement="top">
                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                <i class="bi bi-eraser-fill fs-4"> </i>
                            </button>
                            <template #content>
                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                            </template>
                        </Popper>
                        <button type="button" class="btn btn-light-primary border border-primary" @click="getData()" data-kt-indicator="on">
                            <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                            <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                            </svg>
                            </span>
                            <span v-if="!this.isListProgressing"> {{ $t('list_transactions') }} </span> 
                            <span class="indicator-progress" v-if="this.isListProgressing">
                                {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span> 
                        </button>                        
                    </div>
                    <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                        <div class="fw-bolder me-5">
                        <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                        <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                    </div>
                </div>
            </div>
            <div class="card-body pt-0">
                <div class="row p-3">
                    <form class="form fv-plugins-bootstrap5 fv-plugins-framework p-3 pb-0 pt-1 rounded-2 bg-light">
                        <div class="fv-row mb-7 row">       
                             <div class="col-lg">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('accounting_period') }}</span> 
                                </label>   
                                <Select2 v-model="form.period_id" :options="accountingYears" :settings="{ width: '100%' }" @select="onChangeAccountYear($event, true)"/>  
                            </div>                     
                            <div class="col-lg">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('start_date') }}</span>
                                </label>
                                <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :minDate="this.form.periodSelection.start_date" :maxDate="this.form.periodSelection.end_date"></Datepicker>  
                            </div>
                            <div class="col-lg">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('end_date') }}</span>
                                </label>
                                <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :minDate="this.form.periodSelection.start_date" :maxDate="this.form.periodSelection.end_date"></Datepicker>
                            </div>
                            <div class="col-lg">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('record_type') }}</span>
                                </label>
                                <Select2 v-model="form.is_manuel" :options="transactionTypeList" :settings="{width: '100%'}" />
                            </div>
                            <div class="col-lg">  
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('transaction_location') }}</span>
                                </label>
                                <Select2 v-model="form.SOURCE" :options="transactionLocationList" :settings="{width: '100%'}" />
                            </div>                            
                            <div class="col-lg">
                                <label class="fs-6 fw-bold form-label mt-3">
                                    <span>{{ $t('voucher_type') }}</span>
                                </label>
                                <Select2 v-model="form.docket_type" :options="voucherTypeList" :settings="{ width: '100%' }"/>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div>

                        <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions>
                        <DxDataGrid id="gridContainer" :key="$i18n.locale" :show-borders="true" 
                                    key-expr="source_id" 
                                    :data-source="transactionList" 
                                    :allow-column-reordering="true"  
                                    :allow-column-resizing="true" 
                                    :column-auto-width="true" 
                                    :row-alternatin-enabled="true"
                                    :hover-state-enabled="true" 
                                    :show-row-lines="true"
                                    :ref="'dataGrid'"
                                    @exporting="this.$onExporting($event , 'Accounting-Transaction-List')"> 

                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="10"/>
                                <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/>
                                <DxSearchPanel :visible="true"/>  
                                <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                />
                                <DxColumn data-field="record_date" :caption="$t('record_date')" data-type="date" alignment="right" format="dd.MM.yyyy" cell-template="record_date-cell-template"/> 
                                <DxColumn data-field="source_name" :caption="$t('source_name')" cell-template="source_name-cell-template"/>
                                <DxColumn data-field="transaction_subtype_name" :caption="$t('transaction_sub_type')" cell-template="transaction_subtype_name-cell-template"/>
                                <DxColumn data-field="voucher_type_name" :caption="$t('voucher_type')" cell-template="voucher_type_name-cell-template"/>
                                <DxColumn data-field="transaction_no" :caption="$t('transaction_number')" alignment="right" cell-template="transaction_no-cell-template"/> 
                                <DxColumn data-field="docket_no" :caption="$t('voucher_number')" alignment="right" cell-template="docket_no-cell-template"/> 
                                <DxColumn data-field="serial_no" :caption="$t('serial_no')" alignment="right" cell-template="serial_no-cell-template"/> 
                                <DxColumn data-field="is_manuel_name" :caption="$t('record_type')" cell-template="is_manuel_name-cell-template"/> 
                                <DxColumn data-field="total_debit" :sorting-method="this.$numericSort" :caption="$t('total_debit')" alignment="right" cell-template="total_debit-cell-template"/> 
                                <DxColumn data-field="total_credit" :sorting-method="this.$numericSort" :caption="$t('total_credit')" alignment="right" cell-template="total_credit-cell-template"/> 
                                <DxColumn data-field="transaction_amount" :caption="$t('transaction_amount')" alignment="right" cell-template="transaction_amount-cell-template"/>

                                 <!-- Cell Templates -->
                                <template #record_date-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ previewDate(data.data.record_date) }}
                                    </a>
                                </template>
                                <template #source_name-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)">
                                        <span class="badge badge-circle badge-light me-3">
                                            <i class="bi bi-pencil text-gray-900"></i> 
                                        </span> 
                                        <span class="text-gray-800"> 
                                            {{ data.data.source_name }}
                                        </span> 
                                    </a>
                                </template>
                                <template #voucher_type_name-cell-template="{ data }">
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                      {{ data.data.voucher_type_name }}
                                    </a>
                                </template>
                                <template #docket_no-cell-template="{ data }">  
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.docket_no }}
                                    </a>
                                </template>
                                <template #serial_no-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.serial_no }}
                                    </a>
                                </template>
                                <template #transaction_subtype_name-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.transaction_subtype_name }}
                                    </a>
                                </template>
                                <template #transaction_no-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.transaction_no }}
                                    </a>
                                </template>
                                <template #is_manuel_name-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.is_manuel_name }}
                                    </a>
                                </template>
                                <template #total_debit-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.total_debit }}
                                    </a>
                                </template>
                                <template #total_credit-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.total_credit }}
                                    </a>
                                </template>
                                <template #transaction_amount-cell-template="{ data }"> 
                                    <a href="#" class="text-gray-800 text-hover-primary" @click="updateItem(data.data.source_id)"> 
                                        {{ data.data.transaction_amount }}
                                    </a>
                                </template> 
                                <DxSummary :calculate-custom-summary="setSummaries">
                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="record_date"/>
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="total_debit"
                                        summary-type="custom"
                                        show-in-column="total_debit"
                                        display-format="{0}"
                                    /> 
                                     <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="total_credit"
                                        summary-type="custom"
                                        show-in-column="total_credit"
                                        display-format="{0}"
                                    /> 
                                    <DxTotalItem
                                        name="total_debit"
                                        summary-type="custom"
                                        show-in-column="total_debit"
                                    />
                                    <DxTotalItem
                                        name="total_credit"
                                        summary-type="custom"
                                        show-in-column="total_credit"
                                    />
                                </DxSummary>
                                <DxStateStoring
                                        :enabled="true"
                                        type="custom"
                                        :storage-key="this.storageKey"
                                        :ref="dataGrid" 
                                        :saving-timeout="1000"
                                        :custom-load="LoadDXState"
                                    />
                        </DxDataGrid>                   
                    </div>
                </div> 
            </div>
        </div> 
    </div>  
  </div>  
</template>

<script>
import axios from 'axios' 
import moment from 'moment';

import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem,DxGroupItem, DxSummary, DxScrolling } from 'devextreme-vue/data-grid';
 
export default {
    name: "AccountingVoucherList",
    components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxStateStoring, DxTotalItem,DxGroupItem,DxSummary, DxScrolling
    },
	data() {
        return {
            storageKey: 'dx_' + this.$options.name,
            searchbar: '',
            isListProgressing: false,
            isOpenActionsDropdown: false,      
            page: 1,
            page_size: 10,
            pageSize: 10,
            summary: {},
            accountingYearList: [],
            accountingYearSelection: null,
            accountingYears: [],
            form:  {
                start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
                end_date: moment(),
                is_manuel: 3,
                SOURCE: 0,
                period_id: null,
                periodSelection: {},
                docket_type: -1
            },
            transactionList: [],
            transactionTypeList: [
                { id: 3, text: this.$t('all')},
                { id: 0, text: this.$t('automatic')},
                { id: 1, text: this.$t('manuel')},
                { id: 2, text: this.$t('mixed')}
            ],
            transactionLocationList: [
                { id: 0, text: this.$t('all')},
                { id: 1, text: this.$t('manuel')},
                { id: 2, text: this.$t('all_invoices')},
                { id: 3, text: this.$t('sales_invoice')},
                { id: 4, text: this.$t('purchase_invoice')},
                { id: 5, text: this.$t('sales_return_invoice')},
                { id: 6, text: this.$t('purchase_return_invoice')},
                { id: 7, text: this.$t('cash_transaction')},
                { id: 8, text: this.$t('bank_transaction')},
                { id: 10, text: this.$t('turnover_transaction')},
                { id: 11, text: this.$t('difference_transaction')},
                { id: 12, text: this.$t('chequecard_transaction')},
                { id: 13, text: this.$t('expense_transaction')},
                { id: 14, text: this.$t('offsetting_transaction')},
            ],
            voucherTypeList: [],
            isAccountingYearLoading: false,
            menuSelection: '/AccountingVoucherHelppage',
            iconView : false
        };
  },
  computed: {  
    searchableList() {
      return this.transactionList.slice((this.page - 1) * this.page_size, this.page * this.page_size);
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    previewOnlyDate(){
            return (value)=>{
            if (value) {
                return moment(new Date(value)).format('DD.MM.YYYY')
                }
            }
        },
        getReportTypeValue(){
          return (value)=>{
            if (value) {
                return this.reportTypes.find(p => { 
                    return p.id == value;
                }).text; 
            }
          } 
        },
        getPeriodMonthValue(){
             return (value)=>{
                if (value) {
                    var period = this.periodList.find(p => { 
                        return p.id == value && p.id != '-1';
                    }); 
                    if(period){
                        return period.text;
                    }
                    else{
                        return null;
                    }
              }
          } 
        },
    showPageSizeSelector() {
        return this.transactionList.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.transactionList.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    }
  },
  methods: { 
    getData() {
        this.transactionList = [];
        this.$Progress.start();  
        this.isListProgressing = true;
        this.form.start_date = (this.form.start_date == null || this.form.start_date == '') ? moment() : this.form.start_date;
        this.form.end_date = ( this.form.end_date == null || this.form.end_date == '') ? moment () : this.form.end_date;
        const params = {
            session_id: this.$getUser().session_id,
            start_date: this.form.start_date,
            end_date: this.form.end_date,
            is_manuel: this.form.is_manuel,
            SOURCE: this.form.SOURCE,
            period_id: this.form.period_id,
            docket_type: this.form.docket_type
        };  
        if(params.is_manuel == 3) { params.is_manuel = null }
        if(params.SOURCE == 0) { params.SOURCE = null }
        params.start_date = moment(params.start_date).format('YYYY-MM-DD[T]HH:mm:ss');
        params.end_date = moment(params.end_date).format('YYYY-MM-DD[T]HH:mm:ss');  
        axios.post('api/AccountingTransaction/GetSummary', params, {'Content-Type': 'application/json'}).then((response) => {
            this.transactionList = response.data; 
            this.$setSessionStorage('criterias'+ '_ACTTRS001', this.form);
            this.$setSessionStorage('tmp_period_selection', params.period_id); 
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch(() => { 
            this.$Progress.finish();
        setTimeout(() => {
            this.isListProgressing = false;
        }, 500);
        });
        
    }, 
    updateItem(id){ 
        this.$setSessionStorage('record_id', id);
        this.$router.push({ name: 'AccountingVoucherUpdate' });
    },
    getAccountingYears(){
        this.isAccountingYearLoading = true;
        this.companyAccountingPeriods = [];
        const queryParameter = {
            session_id: this.$getUser().session_id
        };
        axios.post('/api/Auth/GetCompanyAccountingYears', queryParameter, {'Content-Type': 'application/json'})
        .then((response) => {   
                this.accountingYears = response.data;
                if(this.$getSessionStorage('criterias'+ '_ACTTRS001') == '' || this.$getSessionStorage('criterias'+ '_ACTTRS001') == null || this.$getSessionStorage('criterias' + '_ACTTRS001') == undefined) {
                    this.accountingYears.forEach((period) => {
                        if(period.id == this.$getSessionStorage('activeYear')){
                            this.form.period_id = period.id;
                            this.form['periodSelection'] = period; 
                            this.form.start_date = this.form['periodSelection'].start_date;
                            this.form.end_date = this.form['periodSelection'].end_date;
                            this.$setSessionStorage('tmp_period_selection', this.form.period_id);
                        }
                    }); 
                }
                if(this.$getSessionStorage('refreshList')) {
                    this.getData();
                }
                this.$removeSessionStorage('refreshList'); 
                setTimeout(() => {
                    this.isAccountingYearLoading = false;
                }, 1000); 
        })
        .catch((error) => {
            this.isAccountingYearLoading = false;
            console.error(error);
        }); 
    },  
    onChangeAccountYear(e, isChangeForced){
        this.form['periodSelection'] = e; 
        if((e.id != this.$getSessionStorage('activeYear')) || isChangeForced){
            this.form.end_date = moment(e.end_date);
            this.form.start_date = moment(e.start_date);
        } 
    },
    setCriteriasToDefault() {   
        this.form = {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),
            is_manuel: 3,
            SOURCE: 0,
            period_id: null,
            periodSelection: {},
            docket_type: -1
        };
        this.$removeSessionStorage('criterias'+ '_ACTTRS001');
        this.transactionList = [];
        this.getAccountingYears();
    },
    /** DX STATE OPERATIONS **/  
    LoadDXState() {
        return JSON.parse(sessionStorage.getItem(this.storageKey));
    }, 
    getLists() {
        const params = {
           session_id: this.$getUser().session_id,
           tip: 17 //Voucher Type
        };        
        axios.post('/api/Helper/GetConst', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.voucherTypeList = response.data; 
            this.voucherTypeList.unshift({ id: -1, text: this.$t('all')}); 

        })
        .catch((error) => {
            console.error(error); 
        });
    }, 
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/AccountingVoucherHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    },
    setSummaries(options){  
        const optionNames = ["total_credit", "total_debit"]; 
        optionNames.forEach(item => {
            if(options.name == item){
                if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                else if(options.summaryProcess === 'calculate'){
                    var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                    (options.totalValue += itemValue);
                }
                else if(options.summaryProcess === 'finalize'){ 
                    options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                }
            }
        });
    },
  },
  created() {  
    this.helpPageViewIcon();
    this.getLists();
    this.$removeSessionStorage('record_id');  
    try{ 
        if(this.$getSessionStorage('refreshList')){  
            const criteriaData = this.$getSessionStorage('criterias'+ '_ACTTRS001');  
            if (criteriaData !== null && criteriaData !== '' && criteriaData !== undefined)
            {
                this.form = {
                    start_date: moment(criteriaData.start_date),
                    end_date: moment(),
                    is_manuel: criteriaData.is_manuel,
                    SOURCE: criteriaData.SOURCE,
                    period_id: criteriaData.period_id,
                    periodSelection: criteriaData.periodSelection,
                    docket_type: criteriaData.docket_type
                }
            }
        }
        else {
            this.$removeSessionStorage('criterias'+ '_ACTTRS001');
            this.transactionList = [];
        }
        this.getAccountingYears();
    }
    catch{ this.getData(); }
  }
}; 
</script>